export default __webpack_public_path__ + "static/media/user.bf2aa57c.png";